import Intellibrand from "../services/Intellibrand";

export default {

    components: {},
    props: ['eans'],
    data: () => {
        return {
            isOffersModalOpen: false,
            isOffersModalLoading: false,
            isOffersLoadedStyle: false,
            openProduct: null,
            selectedEan: null,
            currency: Intellibrand.currency(),
            hasDecimals: Intellibrand.hasDecimals(),
        }
    },

    beforeMount() {

    },

    mounted() {
        this.loadOffers(this.eans || [], () => {
            this.setupOffersButtons()

        })
    },
    methods: {
        toggleMenu: function () {
            document.getElementById('header').classList.toggle('open')
            document.getElementsByTagName('body')[0].classList.toggle('modal-open')
        },

        onModalSkuChange(ev) {
            console.log("SELECTED EAN", ev.target.value);
            this.selectedEan = ev.target.value;
        },

        setupOffersButtons (){
          let greenContainer = document.querySelector('.component-class-green-pills .page-component');
          let orangeContainer = document.querySelector('.component-class-orange-pills .page-component');
          let cartSvgIcon = document.querySelector("#svg-assets .icon-cart");

          let greenBtn = document.createElement('a');
              greenBtn.className = 'btn btn-rainbow';
              greenBtn.innerHTML = cartSvgIcon.outerHTML + '<span>Comprar</span>';
              greenContainer.appendChild(greenBtn)

              greenBtn.addEventListener('click', () => {
                  this.selectedEan = this.eans[0] || null
                  this.isOffersModalOpen = true;
              })

          let orangeBtn = document.createElement('a');
              orangeBtn.className = 'btn btn-rainbow';
              orangeBtn.innerHTML = cartSvgIcon.outerHTML + '<span>Comprar</span>';
              orangeContainer.appendChild(orangeBtn)

              orangeBtn.addEventListener('click', () => {
                  this.selectedEan = this.eans[1] || null
                  this.isOffersModalOpen = true;
              })


            return

            setTimeout(() => {


                let gradientBorderSvg = document.querySelector('.genova-gradient-button').innerHTML


                let rainbowButtons = document.querySelectorAll('.btn-rainbow');

                rainbowButtons.forEach((btn) => {

                    let borderElement = document.createElement('div')
                        borderElement.classList = 'gradient-border';
                        borderElement.innerHTML = gradientBorderSvg;

                    btn.appendChild(borderElement);
                })

                //console.log(gradientBorderSvg)
            }, 200)

        },


        loadOffers(eans, callback) {
            if(eans.length === 0) return

            console.log("Loading offers for product w/ EANs: ", eans.join(', '));

            this.isOffersModalLoading = true;
            this.isOffersLoadedStyle = false;
            Promise
                .all( Object.values(eans).map((ean) => Intellibrand.fetchOffer(ean)) )
                .then((results) => {
                    this.isOffersModalLoading = false;
                    this.isOffersLoadedStyle = true;

                    console.log("Loaded all offers for EANs: ", eans, results);
                    this.openProduct = results;

                    if (results.length === 1) {
                        this.selectedEan = this.openProduct[0].ean;
                    }

                    this.$forceUpdate();
                    callback();
                })
        },

    }
}
